export const BEGINNING_CREDITS = 5
